import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'

const ErrorPage = () => import('@/views/shopify/TheShopifyErrorPage.vue')

const routes: RouteRecordRaw[] = [
  { path: '/error', name: 'Error', component: ErrorPage },
  { path: '/:pathMatch(.*)*', redirect: { name: 'Error' } }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

export default router
